import { defineMessages } from "react-intl";

export default defineMessages({
  "importRequest.state.Complete": {
    id: "importRequest.state.Complete",
    defaultMessage: "Complete",
  },
  "importRequest.state.Failed": {
    id: "importRequest.state.Failed",
    defaultMessage: "Failed",
  },
  "importRequest.state.Pending": {
    id: "importRequest.state.Pending",
    defaultMessage: "Pending",
  },
  "importRequest.mode.DryRun": {
    id: "importRequest.mode.DryRun",
    defaultMessage: "Dry",
  },
  "importRequest.mode.FullRun": {
    id: "importRequest.mode.FullRun",
    defaultMessage: "Full",
  },
  "importReport.state.Failed": {
    id: "importReport.state.Failed",
    defaultMessage: "Failed",
  },
  "importReport.state.Succeeded": {
    id: "importReport.state.Succeeded",
    defaultMessage: "Succeeded",
  },
});